/* eslint-disable react/jsx-props-no-spreading */
import { InputHTMLAttributes, memo } from 'react';
import { ReactComponent as Downloads } from 'src/shared/assets/icons/downloads.svg';
import { Title } from 'src/shared/ui/title/Title';

import bridge from '@vkontakte/vk-bridge';

import cls from './Upload.module.scss';

interface IUploadProps
  extends Omit<
    InputHTMLAttributes<HTMLInputElement>,
    'id' | 'type' | 'hidden'
  > {
  img?: string;
}

const onClickHandler = () => {
  // @ts-ignore
  bridge.send('VKWebAppSendCustomEvent', {
    event: 'upload_photo_click'
  });
};

export const Upload = memo(({ img, ...props }: IUploadProps) => (
  <label htmlFor='upload' className={cls.label}>
    <input type='file' id='upload' hidden accept='image/*' onClick={onClickHandler} {...props} />
    {!img && (
      <>
        <Title className={cls.p}>ЗАГРУЗИ</Title>
        <Title className={cls.p}>ФОТО</Title>
        <Downloads />
      </>
    )}
    {img && <img className={cls.img} src={img} alt='img' />}
  </label>
));
